import { render } from "./RequiredText.vue?vue&type=template&id=0e12dedd&scoped=true"
import script from "./RequiredText.vue?vue&type=script&lang=js"
export * from "./RequiredText.vue?vue&type=script&lang=js"

import "./RequiredText.vue?vue&type=style&index=0&id=0e12dedd&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/gmX3YL_q/0/internal/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e12dedd"]])

export default __exports__